import React from "react"

const SpeedIconWhite = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7778 4.22222L5 13.5556H12L11.2222 19.7778L19 10.4444H12L12.7778 4.22222Z"
        fill="white"
        stroke="white"
        strokeWidth="1.55556"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="7" r="4.5" fill="white" stroke="var(--theme-green)" />
      <circle
        cx="18"
        cy="17"
        r="4.5"
        fill="white"
        stroke="var(--theme-green)"
      />
    </svg>
  )
}

export default SpeedIconWhite
